import React, { useId } from "react"

export default function RiaOrb({ size = 32, speaking = false, thinking = false }) {
  const rawId = useId()
  const uid = "ria" + rawId.replace(/:/g, "")

  return (
    <span
      style={{ display: "inline-block", width: size, height: size, flex: "0 0 auto" }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 40 40"
        width={size}
        height={size}
        style={{
          display: "block",
          filter: speaking
            ? "drop-shadow(0 0 8px rgba(251,215,106,.55))"
            : "drop-shadow(0 0 4px rgba(111,199,216,.35))",
          transition: "filter .4s ease",
        }}
      >
        <defs>
          <radialGradient id={`${uid}-core`} cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FFF5C9" />
            <stop offset="55%" stopColor="#FBD76A" />
            <stop offset="100%" stopColor="#FBD76A" stopOpacity="0" />
          </radialGradient>
          <linearGradient id={`${uid}-arc-a`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#6FC7D8" />
            <stop offset="100%" stopColor="#26ADC7" />
          </linearGradient>
          <linearGradient id={`${uid}-arc-b`} x1="1" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FBD76A" />
            <stop offset="100%" stopColor="#F6A623" />
          </linearGradient>
        </defs>

        <circle cx="20" cy="20" r="19" fill={`url(#${uid}-core)`} opacity=".35">
          <animate
            attributeName="r"
            values="18;19.5;18"
            dur={thinking ? "1.4s" : "3.6s"}
            repeatCount="indefinite"
          />
        </circle>

        <g style={{ transformOrigin: "20px 20px", animation: "riaSpinA 9s linear infinite" }}>
          <path
            d="M 6 20 A 14 14 0 1 1 34 20"
            fill="none"
            stroke={`url(#${uid}-arc-a)`}
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </g>

        <g style={{ transformOrigin: "20px 20px", animation: "riaSpinB 7s linear infinite" }}>
          <path
            d="M 30 20 A 10 10 0 1 1 10 20"
            fill="none"
            stroke={`url(#${uid}-arc-b)`}
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </g>

        <circle cx="20" cy="20" r="4" fill={`url(#${uid}-core)`}>
          <animate
            attributeName="r"
            values="3.4;4.4;3.4"
            dur={thinking ? "0.9s" : "2.2s"}
            repeatCount="indefinite"
          />
        </circle>

        <circle cx="20" cy="20" r="1.4" fill="#0E1D27" opacity=".85" />
      </svg>
    </span>
  )
}
